import React from 'react';

// styles 
import styles from './Loading.module.css'

const Loading = () => {
    return (
        <div className={styles.container}>
            <div className={styles.loading}>

            </div>
            
        </div>
    );
};

export default Loading;